// Event system to break circular dependencies
class EventEmitter {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((cb) => cb !== callback);
  }

  emit(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event ${event}:`, error);
      }
    });
  }

  removeAllListeners(event) {
    if (event) {
      delete this.events[event];
    } else {
      this.events = {};
    }
  }
}

// Global event bus
export const eventBus = new EventEmitter();

// Event constants
export const EVENTS = {
  CHART_DATA_RELOAD_REQUESTED: "chart_data_reload_requested",
  CHART_DATA_RELOADED: "chart_data_reloaded",
  MARKET_DATA_CONNECTED: "market_data_connected",
  MARKET_DATA_DISCONNECTED: "market_data_disconnected",
  // "Meus Desktops" — list mutated (save/rename/delete/duplicate) → bar refetch
  DESKTOP_LIST_CHANGED: "desktop_list_changed",
  // "Meus Desktops" — request WorkspaceMenus to open the Load Desktop dialog
  OPEN_LOAD_DESKTOP_DIALOG: "open_load_desktop_dialog",
};
